/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Your_KeysInputs */

const en_settings_apikeys_your_keys = /** @type {(inputs: Settings_Apikeys_Your_KeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Keys`)
};

/**
* | output |
* | --- |
* | "Your Keys" |
*
* @param {Settings_Apikeys_Your_KeysInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_your_keys = /** @type {((inputs?: Settings_Apikeys_Your_KeysInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Your_KeysInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_apikeys_your_keys(inputs)
});
export { settings_apikeys_your_keys as "settings.apikeys.your_keys" }